import { render } from "./basicArea.vue?vue&type=template&id=c50c6a98"
import script from "./basicArea.vue?vue&type=script&lang=js"
export * from "./basicArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__